// extracted by mini-css-extract-plugin
export default {"container":"DistributorItem_container__IVYgZ","wrapper":"DistributorItem_wrapper__KG1q0","text":"DistributorItem_text__HDvd8","name":"DistributorItem_name__6xSJ-"};